import { FooterWrapper } from "./Footer.style";
import logoPath from "../../assets/images/logo.jpg";

export const Footer = () => {
  return (
    <FooterWrapper>
      <img src={logoPath} alt={"Platforma Eduś logo"} />
      <div>
        <p>
          Copyright Instytutu Badań Regionalnych Biblioteki Śląskiej 2015-2019©
        </p>
        <address>ul. Ligonia 7, 40-036 Katowice</address>
      </div>
    </FooterWrapper>
  );
};
